class ClientConfig {

    static initRoute ($stateProvider, $urlRouterProvider) {
        'ngInject';
        $stateProvider.state('protected.users.client', {
          url: "/client",
          abstract: true,
          template: require("./client.html")
        }).state('public.users.client', {
          url: "/client",
          abstract: true,
          template: require("./client.html")
        }).state('public.users.client.client-registration', {
          url: "/client-registration",
          template: require("./client-registration.html"),
          controller: "ClientRegistrationUsersController as clientregistration"
        }).state('public.users.client.client-registration-continue', {
          url: "/client-registration-continue",
          params: {
            registrationDataStep1: null
          },
          template: require("./client-registration-continue.html"),
          controller: "ClientRegistrationContinueUsersController as clientregistration"
        }).state('public.users.client.client-activation-confirm', {
          url: "/client-activation-confirm",
          params: {
            userName: null
          },
          template: require("./client-activation-confirm.html"),
          controller: "ClientActivationConfirmUsersController as clientactivationconfirm"
        }).state('public.users.client.client-registration-confirm', {
          url: "/client-registration-confirm",
          params: {
            userName: null
          },
          template: require("./client-registration-confirm.html"),
          controller: "ClientRegistrationConfirmUsersController as clientregistrationconfirm"
        }).state('public.users.client.client-activation-retry', {
          url: "/client-activation-retry",
          template: require("./client-activation-retry.html"),
          controller: "ClientActivationRetryUsersController as clientactivationretry"
        }).state('public.users.client.client-login', {
          url: "/client-login",
          params: {
            email: null
          },
          template: require("./client-login.html"),
          controller: "ClientLoginUsersController as clientlogin"
        }).state('protected.users.client.shareResource', {
          url: "/shareResource/:resourceUniqueId",
          template: require("./shareResource.html"),
          controller: "ShareResourceUsersController as shareresource",
        }).state('protected.users.client.shared-resources', {
          url: "/shared-resources",
          template: require("./client-shared-resources.html"),
          controller: "ClientSharedResourceUsersController as clientsharedresources"
        }).state('public.users.client.activation', {
          url: "/client-activation?email&token&lang",
          template: require("./client-activation.html"),
          controller: "ClientActivationUsersController as clientactivation"
        });
    }
}

export default ClientConfig.initRoute;



// WEBPACK FOOTER //
// ./src/users/client/client.config.js